import React, { useEffect } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import type { GeoPoint, TourStop } from '../../types/deliveryTour';
import 'leaflet/dist/leaflet.css';

const MapResizer: React.FC = () => {
  const map = useMap();
  useEffect(() => {
    const timers = [
      setTimeout(() => map.invalidateSize(), 100),
      setTimeout(() => map.invalidateSize(), 400),
    ];
    return () => timers.forEach((t) => clearTimeout(t));
  }, [map]);
  return null;
};

function pin(color: string) {
  return L.divIcon({
    className: '',
    html: `<div style="width:22px;height:22px;border-radius:999px;background:${color};border:2px solid white;box-shadow:0 1px 4px rgba(0,0,0,.35)"></div>`,
    iconSize: [22, 22],
    iconAnchor: [11, 11],
  });
}

interface TourMapProps {
  stops: TourStop[];
  end?: GeoPoint | null;
}

export const TourMap: React.FC<TourMapProps> = ({ stops, end }) => {
  const mapped = stops.filter(
    (s) => s.latitude != null && s.longitude != null
  );
  const first = mapped[0];
  const center: [number, number] = first
    ? [first.latitude as number, first.longitude as number]
    : end
      ? [end.latitude, end.longitude]
      : [52.52, 13.405];

  return (
    <div className="tour-map relative z-0 h-36 rounded-2xl overflow-hidden border border-gray-200 isolate [&_.leaflet-container]:!z-0 [&_.leaflet-pane]:!z-0 [&_.leaflet-top]:!z-0 [&_.leaflet-bottom]:!z-0 [&_.leaflet-control]:!z-0">
      <MapContainer
        center={center}
        zoom={12}
        className="h-full w-full !z-0"
        scrollWheelZoom={false}
      >
        <MapResizer />
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {mapped.map((stop) => {
          const color =
            stop.status === 'delivered'
              ? '#16a34a'
              : stop.status === 'skipped'
                ? '#9ca3af'
                : '#4f46e5';
          return (
            <Marker
              key={stop.id}
              position={[stop.latitude as number, stop.longitude as number]}
              icon={pin(color)}
            >
              <Popup>
                {stop.sequence_order}. {stop.customer_name}
              </Popup>
            </Marker>
          );
        })}
        {end ? (
          <Marker
            position={[end.latitude, end.longitude]}
            icon={pin('#111827')}
          >
            <Popup>{end.label || 'End'}</Popup>
          </Marker>
        ) : null}
      </MapContainer>
    </div>
  );
};
